import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./dashboard.scss";
import { SearchContext } from "../../App";
import { useSelector } from "react-redux";
import ProvidersSearchResults from "../searchlist/ProvidersSearchResults";
import PracticeSearchResults from "../searchlist/PracticeSearchResults";

export default function Dashboard() {
  const navigateTo = useNavigate();
  const location = useLocation();
  const {
    setSearchPracticeParams,
    setSearchProviderParams,
    searchPracticeParams,
    searchProviderParams,
  } = useContext(SearchContext);
  const [provider, setProvider] = useState(true);
  const [practice, setPractice] = useState(false);

  const { providerSearchItem, proviserSearchErrmsg } = useSelector(
    (state) => state.providerSearchSuggestion
  );
  const { practiceSearchItem, practiceSearchErrmsg } = useSelector(
    (state) => state.practiceSearchSuggestion
  );
   const inputRef = document.querySelector('input[type="search"]');

  useEffect(() => {
    if (location.pathname == "/dashboard/providers") {
      setPractice(false);
      setProvider(true);
    } else if (location.pathname == "/dashboard/practices") {
      setProvider(false);
      setPractice(true);
    }
  });

  const handleProviderPageChange = (pageNum) => {
    setSearchProviderParams((prev) => ({ ...prev, pageNumber: pageNum }));
  };

  const handlePracticePageChange = (pageNum) => {
    setSearchPracticeParams((prev) => ({ ...prev, pageNumber: pageNum }));
  };

  const providerClick = () => {
    navigateTo("/dashboard/providers");
    setPractice(false);
    setProvider(true);
  };
  const practiceClick = () => {
    navigateTo("/dashboard/practices");
    setProvider(false);
    setPractice(true);
  };

  return (
    <div className="dashboard-main">
      <div className="top-search" id="top-search">
        <div
          onClick={providerClick}
          className={`list${provider ? " active" : ""}`}
        >
          Providers{" "}
          {providerSearchItem?.totalItems > 0 && (
            <span>({providerSearchItem?.totalItems})</span>
          )}
          {inputRef?.value === "" ? "" :providerSearchItem?.items?.length === 0 && <span>({0})</span>}
        </div>
        <div
          onClick={practiceClick}
          className={`list${practice ? " active" : ""}`}
        >
          Practices{" "}
          {practiceSearchItem?.totalItems > 0 && (
            <span>({practiceSearchItem?.totalItems})</span>
          )}
          {inputRef?.value === "" ? "" :practiceSearchItem?.items?.length === 0 && <span>({0})</span>}
        </div>
      </div>

      {provider && (
        <div>
          <ProvidersSearchResults
            providerSearch={providerSearchItem}
            onUpdate={handleProviderPageChange}
            searchproviderparams={searchProviderParams}
            providerErrMsg={proviserSearchErrmsg}
          />
        </div>
      )}
      {practice && (
        <div>
          <PracticeSearchResults
            practiceSearch={practiceSearchItem}
            onPracticeUpdate={handlePracticePageChange}
            searchpracticeparams={searchPracticeParams}
            practiceErrMsg={practiceSearchErrmsg}
          />
        </div>
      )}
    </div>
  );
}
